import { useEffect, useState } from "react";
import { api } from "../../api";

export default function MasterView() {
  const [clients, setClients] = useState([]);
  const [stores, setStores] = useState([]);
  useEffect(() => {
    api.get("/clients").then(r => setClients(r.data)).catch(() => {});
    api.get("/stores").then(r => setStores(r.data)).catch(() => {});
  }, []);

  const now = new Date();
  const dateStr = now.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric" });

  const platformStores = (p) => stores.filter(s => s.platform === p);

  return (
    <div data-testid="master-view">
      <div className="topbar">
        <div>
          <div className="page-title">Master <span className="dim">Command Centre</span></div>
          <div className="page-meta">
            <span className="live-dot">Live · Updates every 5 min</span>
            <span>{dateStr}</span>
            <span>All Platforms · All Countries</span>
          </div>
        </div>
        <div className="topbar-right">
          <button className="btn btn-ghost btn-sm">Export Report</button>
          <button className="btn btn-primary">+ New Rule</button>
        </div>
      </div>

      <div className="master-banner">
        <div className="master-icon">👑</div>
        <div className="master-text">
          <div className="master-label">Master Access Only</div>
          <div className="master-title">Full Company View — All Clients, All Platforms, All Countries</div>
          <div className="master-sub">This view is exclusive to Master. Clients and planners see only their assigned stores.</div>
        </div>
      </div>

      <div className="country-strip">
        <div className="country-tile active"><div className="ct-flag">🌏</div><div><div className="ct-name">All Markets</div><div className="ct-spend">RM 28.4k</div></div></div>
        <div className="country-tile"><div className="ct-flag">🇲🇾</div><div><div className="ct-name">Malaysia</div><div className="ct-spend">RM 18.2k</div></div></div>
        <div className="country-tile"><div className="ct-flag">🇸🇬</div><div><div className="ct-name">Singapore</div><div className="ct-spend">SGD 4.1k</div></div></div>
        <div className="country-tile"><div className="ct-flag">🇮🇩</div><div><div className="ct-name">Indonesia</div><div className="ct-spend">IDR 12.3M</div></div></div>
      </div>

      <div className="stats-grid">
        <div className="stat-card"><div className="stat-platform-line" style={{ background: "linear-gradient(90deg,var(--shopee),var(--lazada-bright),var(--tiktok-bright))" }} /><div className="stat-label">Total Ad Spend (MTD)</div><div className="stat-value">RM 28.4k</div><div className="stat-change up">↑ 12% vs last month</div></div>
        <div className="stat-card"><div className="stat-platform-line" style={{ background: "var(--green)" }} /><div className="stat-label">Total GMV (Ads)</div><div className="stat-value">RM 214k</div><div className="stat-change up">↑ 18% vs last month</div></div>
        <div className="stat-card"><div className="stat-platform-line" style={{ background: "var(--accent)" }} /><div className="stat-label">Blended ROAS</div><div className="stat-value">7.5×</div><div className="stat-change up">↑ 0.4× vs last month</div></div>
        <div className="stat-card"><div className="stat-platform-line" style={{ background: "var(--blue)" }} /><div className="stat-label">Active Stores</div><div className="stat-value">{stores.length}</div><div className="stat-change neutral">Across all platforms</div></div>
        <div className="stat-card"><div className="stat-platform-line" style={{ background: "var(--yellow)" }} /><div className="stat-label">Pending Approvals</div><div className="stat-value" style={{ color: "var(--yellow)" }}>2</div><div className="stat-change neutral">Needs sign-off</div></div>
      </div>

      <div className="platform-row">
        {[["shopee","Shopee","🛍️","var(--shopee)","var(--shopee-dim)"],["lazada","Lazada","🔵","var(--lazada-bright)","var(--lazada-dim)"],["tiktok","TikTok Shop","🎵","var(--tiktok-bright)","var(--tiktok-dim)"]].map(([p,name,icon,color,dim]) => (
          <div className="platform-card" key={p}>
            <div className="platform-header">
              <div className="platform-name"><div className="platform-logo" style={{ background: dim }}>{icon}</div>{name}</div>
              <span className={`badge b-${p}`}>{platformStores(p).length} stores</span>
            </div>
            <div className="mini-chart">
              {[55,70,60,80,75,90,85].map((h,i) => <div key={i} className="bar" style={{ height: `${h}%`, background: color, opacity: 0.5 + i*0.08 }} />)}
            </div>
            <div className="pmetric"><div className="pmetric-label">Spend MTD</div><div className="pmetric-val">RM {p === "shopee" ? "14.2k" : p === "lazada" ? "9.1k" : "5.1k"}</div></div>
            <div className="pmetric"><div className="pmetric-label">GMV</div><div className="pmetric-val" style={{ color: "var(--green)" }}>RM {p === "shopee" ? "108k" : p === "lazada" ? "72k" : "34k"}</div></div>
            <div className="pmetric"><div className="pmetric-label">ROAS</div><div className="pmetric-val">{p === "shopee" ? "7.6×" : p === "lazada" ? "7.9×" : "6.7×"}</div></div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-header">
          <div><div className="card-title">Client Overview</div><div className="card-sub">All clients · Real-time spend & performance</div></div>
        </div>
        <table>
          <thead><tr><th>Client</th><th>Stores</th><th>Status</th></tr></thead>
          <tbody>
            {clients.map((c) => (
              <tr key={c.id} data-testid={`client-row-${c.id}`}>
                <td><div style={{ fontWeight: 600 }}>{c.avatar} {c.name}</div></td>
                <td><span className="perf-sub">{stores.filter(s => s.client_id === c.id).length} stores</span></td>
                <td><span className={`badge ${c.status === "active" ? "b-active" : "b-pending"}`}>● {c.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
